var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record-box"},[_c('el-button',{on:{"click":_vm.luyin}},[_vm._v("录音开始")]),_c('LuyinBtn')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }